// 国籍/地区
export const cities = [
  '中国',
  '中国台湾',
  '中国香港',
  '中国澳门',
  '安道尔',
  '阿拉伯联合酋长国',
  '阿富汗',
  '安提瓜和巴布达',
  '韩国',
  '日本',
  '东帝汶',
  '阿联酋',
  '巴基斯坦',
  '沙特阿拉伯',
  '巴林',
  '印尼',
  '泰国',
  '尼泊尔',
  '卡塔尔',
  '土耳其',
  '孟加拉国',
  '哈萨克斯坦',
  '缅甸',
  '越南',
  '阿曼',
  '菲律宾',
  '黎巴嫩',
  '巴勒斯坦',
  '亚美尼亚',
  '土库曼斯坦',
  '蒙古',
  '老挝',
  '柬埔寨',
  '科威特',
  '塞浦路斯',
  '阿塞拜疆',
  '塔吉克斯坦',
  '朝鲜',
  '文莱',
  '伊朗',
  '新加坡',
  '伊拉克',
  '斯里兰卡',
  '格鲁吉亚',
  '吉尔吉斯斯坦',
  '印度',
  '不丹',
  '也门',
  '以色列',
  '叙利亚',
  '马尔代夫',
  '马来西亚',
  '乌兹别克斯坦',
  '瑞士',
  '英国',
  '瑞典',
  '意大利',
  '马其顿',
  '白俄罗斯',
  '克罗地亚',
  '塞尔维亚共和国',
  '捷克',
  '希腊',
  '波黑',
  '卢森堡',
  '立陶宛',
  '保加利亚',
  '爱沙尼亚',
  '黑山共和国',
  '德国',
  '冰岛',
  '摩纳哥',
  '乌克兰',
  '罗马尼亚',
  '拉托维亚',
  '丹麦',
  '荷兰',
  '奥地利',
  '马耳他',
  '梵蒂冈',
  '斯洛伐克',
  '阿尔巴尼亚',
  '芬兰',
  '挪威',
  '比利时',
  '葡萄牙',
  '匈牙利',
  '圣马力诺',
  '斯洛文尼亚',
  '法国',
  '波兰',
  '西班牙',
  '爱尔兰',
  '俄罗斯',
  '摩尔多瓦',
  '列支敦士登',
  '贝宁',
  '南非',
  '吉布提',
  '尼日尔',
  '赞比亚',
  '尼日利亚',
  '阿尔及利亚',
  '毛里塔尼亚',
  '埃及',
  '加蓬',
  '几内亚',
  '冈比亚',
  '博茨瓦纳',
  '塞内加尔',
  '埃塞俄比亚',
  '中非共和国',
  '加纳',
  '安哥拉',
  '肯尼亚',
  '卢旺达',
  '科特迪瓦',
  '塞拉利昂',
  '厄立特里亚',
  '马达加斯加',
  '马里',
  '布隆迪',
  '利比亚',
  '索马里',
  '斯威士兰',
  '津巴布韦',
  '几内亚比绍',
  '刚果共和国',
  '苏丹',
  '喀麦隆',
  '莱索托',
  '塞舌尔',
  '莫桑比克',
  '坦桑尼亚',
  '赤道几内亚',
  '刚果民主共和国',
  '乍得',
  '科摩罗',
  '摩洛哥',
  '突尼斯',
  '毛里求斯',
  '利比里亚',
  '布基纳法索',
  '圣多美和普林西比',
  '多哥',
  '佛得角',
  '马拉维',
  '乌干达',
  '纳米比亚',
  '美国',
  '秘鲁',
  '加拿大',
  '墨西哥',
  '委内瑞拉',
  '洪都拉斯',
  '哥斯达黎加',
  '巴西',
  '阿根廷',
  '牙买加',
  '苏里南',
  '萨尔瓦多',
  '圣卢西亚',
  '智利',
  '巴哈马',
  '巴拿马',
  '玻利维亚',
  '厄瓜多尔',
  '尼加拉瓜',
  '圣基茨和尼维斯',
  '古巴',
  '伯利兹',
  '乌拉圭',
  '巴巴多斯',
  '格林纳达',
  '多米尼加',
  '特立尼达和多巴哥',
  '海地',
  '圭亚那',
  '巴拉圭',
  '哥伦比亚',
  '危地马拉',
  '多米尼克',
  '圣文森特和格林纳丁斯',
  '帕劳',
  '瑙鲁',
  '图瓦卢',
  '澳大利亚',
  '马绍尔群岛',
  '斐济',
  '萨摩亚',
  '基里巴斯',
  '库克群岛',
  '巴布亚新几内亚',
  '汤加',
  '新西兰',
  '瓦努阿图',
  '所罗门群岛',
  '密克罗尼西亚',
  '其它',
];

// 民族
export const nation = [
  '汉族',
  '傣族',
  '德昂族',
  '侗族',
  '东乡族',
  '独龙族',
  '鄂伦春族',
  '俄罗斯族',
  '鄂温克族',
  '高山族',
  '仡佬族',
  '朝鲜族',
  '哈尼族',
  '哈萨克族',
  '赫哲族',
  '回族',
  '基诺族',
  '京族',
  '景颇族',
  '柯尔克孜族',
  '拉祜族',
  '黎族',
  '阿昌族',
  '傈僳族',
  '珞巴族',
  '满族',
  '毛南族',
  '门巴族',
  '蒙古族',
  '苗族',
  '仫佬族',
  '纳西族',
  '怒族',
  '白族',
  '普米族',
  '羌族',
  '撒拉族',
  '畲族',
  '水族',
  '塔吉克族',
  '塔塔尔族',
  '土族',
  '土家族',
  '佤族',
  '保安族',
  '维吾尔族',
  '乌兹别克族',
  '锡伯族',
  '瑶族',
  '彝族',
  '裕固族',
  '藏族',
  '壮族',
  '布朗族',
  '布依族',
  '达斡尔族',
];

// 婚姻状况
export const marriage = ['未婚', '已婚', '保密', '离异'];

// 政治面貌
export const polity = ['中国共产党党员', '其它党派', '无党派民主人士', '群众', '共青团员'];

// 证件类型
export const credentials = ['身份证', '护照', '军官证', '香港身份证', '澳门身份证', '台胞证', '台湾身份证', '其他'];

// 学位
export const degree = ['学士', '硕士', 'MBA', '博士', '双学士', '无'];

// 最高学历
export const highestEducation = [
  '初中及以下',
  '中专',
  '大专',
  '高中',
  '技校/职高',
  '本科',
  '硕士研究生',
  '博士研究生',
  'MBA',
  'EMBA',
  'MPA',
  '其它',
];

// 语种
export const language = [
  '英语',
  '韩语',
  '日语',
  '德语',
  '法语',
  '西班牙语',
  '俄语',
  '朝鲜语',
  '阿拉伯语',
  '粤语',
  '其它',
  '无',
];

// 能力
export const abilityLevel = ['普通', '良好', '精通', '熟练'];

// 分类图标名 
export const RECRUIT_CATAGORY_ICON = {
  社会招聘: 'icon-sh.png',
  校园招聘: 'icon-xy.png',
};
